import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { DLG_BTN_PRIMARY } from '@/components/ui/dialogButtons';

interface InfoDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

export const InfoDialog: React.FC<InfoDialogProps> = ({
  open,
  onClose,
  title,
  description = '',
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="
          z-[70] w-[95%] sm:max-w-md mx-auto rounded-xl shadow-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-[#1c1c1e] p-4 sm:p-6 max-h-[80vh] overflow-y-auto
          data-[state=open]:animate-in data-[state=open]:zoom-in-95 data-[state=open]:fade-in-0
          data-[state=open]:ease-out data-[state=open]:duration-300
          data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=closed]:fade-out-0 data-[state=closed]:duration-200
        "
      >
        <DialogHeader>
          <DialogTitle className="text-lg sm:text-xl font-semibold text-[#103254] dark:text-blue-400">
            {title ?? t('infoDialog.defaultTitle')}
          </DialogTitle>
        </DialogHeader>

        <div
          className="rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4 mt-3 text-sm sm:text-base text-gray-700 dark:text-gray-300 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: description }}
        />

        <DialogFooter className="mt-6">
          <Button onClick={onClose} className={`w-full ${DLG_BTN_PRIMARY}`}>
            {t('infoDialog.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};